"use client";

import { useState } from "react";
import { Share2, Check, Link2 } from "lucide-react";

type Props = {
  url: string;
  title: string;
};

/**
 * Share-Leiste für Blog-Artikel.
 * Bietet Links zu LinkedIn, X/Twitter und einen Kopier-Button,
 * der den aktuellen Seiten-Link in die Zwischenablage legt.
 */
export function ShareActions({ url, title }: Props) {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      // 1. moderner Weg
      if (
        typeof navigator !== "undefined" &&
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(url);
      } else {
        // 2. Fallback für nicht-HTTPS Umgebungen
        const textarea = document.createElement("textarea");
        textarea.value = url;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      console.error("copy link failed", err);
    }
  };

  return (
    <div
      className="mt-10 flex flex-wrap items-center gap-3 border-t pt-6"
      style={{ borderColor: "var(--border)" }}
    >
      <Share2 className="h-4 w-4" style={{ color: "var(--text-secondary)" }} />
      <span
        className="text-sm font-medium"
        style={{ color: "var(--text)" }}
      >
        Artikel teilen:
      </span>

      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-primary hover:underline"
      >
        LinkedIn
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-primary hover:underline"
      >
        X / Twitter
      </a>

      <button
        type="button"
        onClick={copyLink}
        aria-live="polite"
        className="ml-auto inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors hover:border-primary/40 hover:text-primary"
        style={{
          borderColor: "var(--border)",
          color: copied ? "var(--fi-success-fg)" : "var(--text-secondary)",
          backgroundColor: copied ? "var(--fi-success-bg)" : "transparent",
        }}
      >
        {copied ? (
          <>
            <Check className="h-3.5 w-3.5" />
            Link kopiert
          </>
        ) : (
          <>
            <Link2 className="h-3.5 w-3.5" />
            Link kopieren
          </>
        )}
      </button>
    </div>
  );
}
